import { LinearProgress } from "@material-ui/core"
import PropTypes from "prop-types"
import { useContext, useEffect, useState } from "react"
import { useQuery } from "react-query"
import { listClients } from "~/actions/clients"
import { listCourses } from "~/actions/courses"
import { listPaths } from "~/actions/paths"
import work2 from "~/assets/Icons/work.svg"
import work from "~/assets/Icons/work_colored.svg"
import ClientHeader from "~/components/Clients/ClientHeader"
import UnsavedChanges from "~/components/Clients/UnsavedChanges"
import ContentTabs from "~/components/Common/ContentTabs"
import AppContext from "~/contexts/App"
import ClientContext, { ClientContainer } from "~/contexts/Client"
import CreateEditAccessLink from "~/dialogs/CreateEditAccessLink"
import Page from "~/pages/Page"
import Router from "~/router"
import Box from "../../../../components/Common/Box"

const Client = ({ routes = [], ...rest }) => {
  const [client, setClient] = useState(null)
  const [clientLoading, setClientLoading] = useState(false)
  const [onlyOnce, setOnlyOnce] = useState(true)
  const { authUser } = useContext(AppContext)
  const { data: clients } = useQuery("clients", () => listClients(), {
    enabled: !!authUser,
  })
  const tabs = [
    {
      label: "Client Details",
      link: `/clients/${rest?.match?.params?.client_id}`,
      icon1: work2,
      icon2: work,
    },
    {
      label: "Dashboard Details",
      link: `/clients/${rest?.match?.params?.client_id}/dashboard`,
      icon1: work2,
      icon2: work,
    },
  ]

  useEffect(() => {
    if (onlyOnce) {
      setClientLoading(true)
    }
    if (clients) {
      setClient(
        clients?.filter(
          (c) => Number(c.id) === Number(rest?.match?.params?.client_id),
        )?.[0],
      )
      if (onlyOnce) {
        setTimeout(() => {
          setClientLoading(false)
          setOnlyOnce(false)
        }, 500)
      }
    }
  }, [clients])

  return (
    <Page>
      <ClientContainer client={client}>
        <Box display="flex" flexDirection="column" height="100%" width="100%">
          <ClientWrapper clientLoading={clientLoading} client={client}>
            <Box flexShrink={0} flexGrow={0} width="100%">
              <ClientHeader client={client} />
              <ContentTabs tabs={tabs} />
            </Box>
            <Box flexGrow={1} overflow="auto">
              <Router routes={routes} {...rest} />
            </Box>
          </ClientWrapper>
        </Box>
        <UnsavedChanges />
        <CreateEditAccessLink />
      </ClientContainer>
    </Page>
  )
}

const ClientWrapper = ({ children, clientLoading, client }) => {
  const { data: courses } = useQuery("courses", () => listCourses())
  const { data: learningPaths } = useQuery("paths", () => listPaths())

  //set courses and paths data for dashboard details section

  const {
    setDashboardCourses,
    setDashboardLearningPaths,
    setInitialDashboardCourses,
    setInitialDashboardLearningPaths,
  } = useContext(ClientContext)

  useEffect(() => {
    if (client?.dashboard_courses?.length > 0 && courses?.length > 0) {
      const dashboardCourses = client.dashboard_courses.map((nc) =>
        courses.find((c) => c.id === nc.id),
      )
      setDashboardCourses(dashboardCourses)
      setInitialDashboardCourses(dashboardCourses)
    }
  }, [client?.dashboard_courses, courses])

  useEffect(() => {
    if (
      client?.dashboard_learning_paths?.length > 0 &&
      learningPaths?.length > 0
    ) {
      const paths = client?.dashboard_learning_paths.map((id) =>
        learningPaths.find((lp) => lp.id == id),
      )
      setDashboardLearningPaths(paths)
      setInitialDashboardLearningPaths(paths)
    }
  }, [client?.dashboard_learning_paths, learningPaths])

  if (clientLoading) {
    return <LinearProgress />
  } else {
    return children
  }
}

ClientWrapper.propTypes = {
  routes: PropTypes.array,
  children: PropTypes.node,
  clientLoading: PropTypes.bool,
  client: PropTypes.any,
}

Client.propTypes = {
  routes: PropTypes.array,
}
ClientWrapper.propTypes = {
  children: PropTypes.node,
  clientLoading: PropTypes.bool,
  client: PropTypes.object,
  courses: PropTypes.array,
  learningPaths: PropTypes.array,
}

export default Client
